import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Layout from '@/components/layout/Layout';

const NotFound = () => {
  return (
    <Layout>
      <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="not-found-page">
        <div className="text-center max-w-lg">
          <div className="relative mb-8">
            <span className="text-[160px] md:text-[200px] font-black text-slate-100 leading-none select-none font-heading">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <Search className="w-16 h-16 text-orange-500 opacity-60" />
            </div>
          </div>

          <h1 className="font-heading text-2xl md:text-3xl font-bold text-slate-900 mb-3">
            Ops! Pagina nao encontrada
          </h1>
          <p className="text-slate-500 mb-8 text-base">
            A pagina que voce procura nao existe ou foi movida. Que tal voltar para a Home e conferir nossas ofertas?
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-6">
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Voltar para a Home
              </Link>
            </Button>
            <Button asChild variant="outline" className="px-8 py-6">
              <Link to="/ofertas">
                <Search className="w-4 h-4 mr-2" />
                Ver Ofertas
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
